<template>
    <div class="diagnosticResults  diagnosticResults-mobile ">
        <div class="diagnosticResults-header">
            <h2 class="mt-2">
                Результаты диагностики
                <span class="badge" :class="getPassTypeBadgeClass(data)">{{ data.passTypeName }}</span>
            </h2>
            <div class="header-container">
                <div class="header-top">
                    <div class="header-info">
                        <div class="info-item">
                            <p>Дисциплина</p>
                            <div class="disp-name">{{ data.studyDisciplineName }}</div>
                        </div>
                        <div class="info-item">
                            <p>Тема</p>
                            <div class="topic-name">{{ data.studyTopicName }}</div>
                        </div>
                    </div>
                    <div v-if="dialog" class="header-time">
                        <p>Дата прохождения:</p>
                        <v-select
                            label=""
                            :items="results"
                            item-value="id"
                            item-text="passDate"
                            variant="outlined"
                            class="comboboxTime"
                            :value="data"
                            :disabled="loading"
                            @change="setCurrentResult"
                        ></v-select>
                    </div>
                    <div v-else class="header-time">
                        <p>Дата прохождения: <b>{{ data.createdDate | filterBirthday }}</b></p>
                    </div>
                </div>
                <div class="header-bot">
                    <h3>{{ data.title }}</h3>
                    <div class="header-patient">
                        <div class="patient-info">
                            <div class="item-name">
                                <img :src="getPhotoUrl(data.patient)" class="name-icon" alt="icon">
                                <div class="name-txtContainer">
                                    <span>{{ data.patient.fio }}</span>
                                    <div class="patient-itemInfo">
                                        <div class="gender-container">
                                            <span>Пол:</span>
                                            <div class="gender" :class="{'male':gender === 'М','female':gender === 'Ж'}">{{ gender }}</div>
                                        </div>
                                        <div class="gender-container">
                                            <span>Возраст:</span>
                                            <div class="age-txt">{{ data.patient.episodes[0].ageValue | calculateAgeByDays }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="item-test">
                                <p>Описание теста</p>
                                <div class="test-name">
                                    <p>{{ data.description  }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="header-stats">
                            <div class="stats-item">
                                <p>Время прохождения</p>
                                <p>
                                    <timerComponent :time="prettyTime" />
                                </p>
                            </div>
                            <div class="stats-item" :style="`background: ${getScoreColor(data.score)}`">
                                <p>Общий балл</p>
                                <p>{{ data.score }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="diagnosticResults-body">
            <h3>Таблица с критериями</h3>
            <v-data-table
                class="elevation-1 diagnosticResults_table"
                ref="taskTable"
                :items="data.criteries"
                :headers="headers"
                hide-default-footer
            >
                <template v-slot:item="{item}">
                    <tr style="width: 100%;">
                        <td>
                            {{ item.title }}
                        </td>
                        <td>
                            {{ item.score }}
                        </td>
                        <td>
                            {{ item.scoreText }}<br>
                            <a @click.prevent="item.isOpen = !item.isOpen" rel="noopener noreferrer">{{ item.isOpen ? 'Скрыть' : 'Посмотреть' }} правильный ответ</a>
                        </td>
                        <td>
                            <a :href="item.link" target="_blank" rel="noopener noreferrer">{{ `${item.link}` }}</a>
                        </td>
                    </tr>
                    <v-expand-transition>
                        <tr style="border: 2px solid rgb(240, 236, 236); vertical-align: baseline;" v-if="item.isOpen">
                            <td colspan="2">
                                <th>Правильный ответ</th>
                                <p v-if="item.title === 'Время диагностики'">
                                    <timerComponent :time="etalonTime" />
                                </p>
                                <!-- <span v-if="item.title === 'Время диагностики'"> {{data.etalonMinutes}}{{ index }} </span> -->
                                <div v-for="(it, index) in item.correctAnswers" :key="index">
                                    <span>{{ it.sectionName ? it.sectionName : ''}} </span>
                                    <span v-if="item.title === 'Постановка синдромального диагноза'">{{it.diagnoseName}} {{ it.diagnoseCode }} </span>
                                    <span v-if="item.title === 'Постановка предварительного диагноза'">{{ it.diagnoseName ? it.diagnoseName : ''}} {{ it.diagnoseCode }} </span>
                                    <span v-if="item.title === 'Постановка окончательного диагноза'">{{ it.diagnoseName ? it.diagnoseName : ''}} {{ it.diagnoseCode }} </span>
                                    <span v-if="item.title === 'Выбор лабораторных исследований' || item.title === 'Выбор инструментальных исследований'">
                                        <span v-if="it.valueType === 1">
                                            {{ it.propertyName }}: {{ it.listValueName }}
                                        </span>
                                        <span v-if="it.valueType === 0">
                                            {{ it.propertyName }}: {{ it.avgValue }} {{ it.measurementName }}
                                        </span>
                                    </span>
                                    <span v-if="item.title === 'Порядок лабораторных исследований' || item.title === 'Порядок инструментальных исследований'">
                                        <span v-if="it.valueType === 1">
                                            {{it.groupName}}: {{ it.propertyName }}({{ it.listValueName }})
                                        </span>
                                        <span v-if="it.valueType === 0">
                                            {{it.groupName}}:{{ it.propertyName }}({{ it.avgValue }}) {{ it.measurementName }}
                                        </span>
                                    </span>
                                    <span v-if="item.title === 'Определение патологии'">
                                        <span v-if="it.valueType !== null && it.valueType === 1">
                                            {{ it.pathologyName }}: {{ it.listValueName }}
                                        </span>
                                        <span v-if="it.valueType !== null && it.valueType === 0">
                                            {{ it.pathologyName }}: {{ it.avgValue }} {{ it.measurementName }}
                                        </span>
                                        <span v-if="it.valueType === null">
                                            <p>{{ it.pathologyName }}</p>
                                        </span>
                                    </span>
                                </div>
                            </td>
                            <td colspan="2">
                                <th style="margin-top: 0;">Ответ студента</th>
                                <p v-if="item.title === 'Время диагностики'">
                                    <timerComponent :time="prettyTime" />
                                </p>
                                <div v-for="(it, index) in item.studentAnswers" :key="index">
                                    <span>{{ it.sectionName ? it.sectionName : ''}} </span>
                                    <span v-if="item.title === 'Постановка синдромального диагноза'">{{it.diagnoseName}} {{ it.diagnoseCode }} </span>
                                    <span v-if="item.title === 'Постановка предварительного диагноза'">{{ it.diagnoseName ? it.diagnoseName : ''}} {{ it.diagnoseCode }} </span>
                                    <span v-if="item.title === 'Постановка окончательного диагноза'">{{ it.diagnoseName ? it.diagnoseName : ''}} {{ it.diagnoseCode }} </span>
                                    <span v-if="item.title === 'Выбор лабораторных исследований' || item.title === 'Выбор инструментальных исследований'">
                                        <span v-if="it.answerValueType === 0">
                                            {{ it.answerGroupName }}: {{ it.answerPropertyName }} ({{ it.answerAvgValue ? it.answerAvgValue : '' }}) {{ it.answerMeasurementName }}
                                        </span>
                                        <span v-if="it.answerValueType === 1">
                                            {{ it.answerGroupName }}: {{ it.answerPropertyName }} ({{ it.answerListValueName}})
                                        </span>
                                    </span>
                                    <span v-if="item.title === 'Порядок лабораторных исследований' || item.title === 'Порядок инструментальных исследований'">
                                        <span v-if="it.answerValueType === 0">
                                            {{ it.answerGroupName }}: {{ it.answerPropertyName }} ({{ it.answerAvgValue ? it.answerAvgValue : '' }}) {{ it.answerMeasurementName }}
                                        </span>
                                        <span v-if="it.answerValueType === 1">
                                            {{ it.answerGroupName }}: {{ it.answerPropertyName }} ({{ it.answerListValueName}})
                                        </span>
                                    </span>
                                    <span v-if="item.title === 'Определение патологии'">
                                         <span v-if="it.valueType !== null && it.valueType === 1">
                                            {{ it.pathologyName }}: {{ it.listValueName }}
                                        </span>
                                        <span v-if="it.valueType !== null && it.valueType === 0">
                                            {{ it.pathologyName }}: {{ it.avgValue }} {{ it.measurementName }}
                                        </span>
                                        <span v-if="it.valueType === null">
                                            <p>{{ it.pathologyName }}</p>
                                        </span>
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </v-expand-transition>
                </template>
            </v-data-table>
        </div>
        <div class="diagnosticResults-btn">
            <v-btn :disabled="loadSaveResult" color="#4854FE" @click="back">{{ dialog ? 'Закрыть' : 'Вернуться к списку тестов' }}</v-btn>
            <!-- <v-btn :loading="loadSaveResult" @click="saveResult(data)" color="primary" class="ml-2">Сохранить результат</v-btn> -->
        </div>
    </div>
</template>

<script>
import timerComponent from '@/components/Timer/index.vue';
import { mapActions, mapGetters } from 'vuex';
import { helpers } from '@/store/tests';

export default {
    name: 'DiagnosticResults',
    components: { timerComponent },
    props: {
        data: { type: Object, default: () => {} },
        results: { type: Array, default: () => [] },
        dialog: { type: Boolean, default: false },
        loading: { type: Boolean, default: false }
    },
    computed: {
        ...mapGetters({
			userRoles: "login/userRoles",
			userInfo: "user/userInfo",
            apiUrl: 'apiUrl'
		}),
        time() {
            let s = this.data.timer.split('T')[1],
                hour = +s.split(':')[0],
                min = +s.split(':')[1],
                sec = +s.split(':')[2];

            if (hour > 0 || min > 0 || sec > 0) {
                return ((hour * 60) * 60 ) + (min * 60) + sec;
            }
            else {
                return 0;
            }
        },
        prettyTime () {
            let hours = this.time / 3600  % 24,
                minutes = this.time / 60 % 60,
                seconds = this.time % 60;

            return `${Math.floor(hours)}:${Math.floor(minutes)}:${Math.floor(seconds)}`
		},
        etalonTime () {
            // console.log(this.data.etalonMinutes);
            let hours = this.data.etalonMinutes / 60,
                minutes = this.data.etalonMinutes % 60,
                seconds = 0
            // console.log(hours, minutes, seconds);
            return `${Math.floor(hours)}:${Math.floor(minutes)}:${Math.floor(seconds)}`
		}
    },
    data() {
        return {
            passTypes: [],
            loadSaveResult: false,
            discipline: 'Название дисциплины 1',
            Subject: 'Название темы 1',
            select: '21.12.2020',
            test: 'Название задания',
            items: ['21.12.2020','22.12.2020','23.12.2020'],
            name: 'Григорьева Александра Константиновна',
            gender: 'М',
            age: 5,
            testName1: 'Название теста в 2 строки',
            testName2: null,
            headers: [
                { text: 'Наименование', value: 'title', width: '29%', sortable: false },
                { text: 'Количество набранных баллов', value: 'score', width: '24%', sortable: false },
                { text: 'Комментарий', value: 'comment', width: '24%', sortable: false },
                { text: 'Ссылка/ссылки на обучающий материал в Системе', value: 'link', width: '23%', sortable: false },
            ]
        }
    },
    methods: {
        ...mapActions({
            saveResultTest: 'takeDiagnosticTest/saveResultTest',
            randomGenerate: 'tests/randomGenerate'
        }),
        loadPassTypes() {
            this.$http.get(`${this.apiUrl}TestTask/GetPassTypes`)
                .then((response) => {
                    this.passTypes = response.data;
            });
        },
        getPassTypeId(keyName) {
            let found = this.passTypes.find(x => x.keyName === keyName);

            if (found !== undefined) {
                return found.id;
            }

            return null;
        },
        getPassTypeBadgeClass(result) {
            if (result.passTypeId === this.getPassTypeId('SelfStudy')) {
                return 'badge-selfstudy';
            }

            if (result.passTypeId === this.getPassTypeId('Control')) {
                return 'badge-control';
            }

            return '';
        },
        getPhotoUrl(student) {
            if (student.logoUrl) {
                return `${this.apiImg}${student.logoUrl}`;
            }

            if (student.gender === 0) {
                return require('@/assets/img/avatar-boy.png');
            }

            if (student.gender === 1) {
                return require('@/assets/img/avatar-girl.png');
            }

            return require('@/assets/img/default-profile-image.png');
        },
        setCurrentResult(id) {
            this.$emit('update', id);
            // console.log('setCurrentResult');
            // this.addCommentGenerate();
        },
        back() {
            if (this.dialog) {
                this.$emit('close');
            } else {
                this.$router.replace(this.userRoles === 'Student' ? '/lkstudents/tests' : this.userRoles === 'Teacher' ? '/teacher/tasks' : '/lk/test-tasks');
            }
        },
        getScoreColor(score) {
            return helpers.getScoreColor(score);
        }
    },
    created() {
        this.loadPassTypes();
    }
}

</script>
